
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[form]/your-donation",
      function () {
        return require("private-next-pages/[form]/your-donation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[form]/your-donation"])
      });
    }
  